import React from 'react';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

// custom hooks
import useRouteMatch from '../../hooks/useRouteMatch';

// components
import { NioMedia } from '../../components';


export default function Footer({ variant = 1, children }) {

  const location = useLocation();

  const compClasses = classNames({
    [`${useRouteMatch("/") ? "nl-footer-landing" : "nl-footer"}`]: true,
  });

  // Use `variant` to silence unused-var warnings while keeping the prop
  // available for future layout variants.
  void variant;
  void location;

  return (
    <footer className={compClasses}>
      {children ? children : (
        <>
          <div className="nl-footer-top">
            <Container>
              <Row className="nl-footer-content justify-content-between gy-5 gy-lg-0 gx-5 pt-5 pt-lg-7">

                {/* Platform */}
                <Col sm="6" lg="3">
                  <div className="nl-footer-info">
                    <h5 className="mb-3 mb-md-4">Platform</h5>
                    <ul className="row gy-1 gy-sm-3">
                      {[
                        { label: 'Farm Mapping', to: '/farm-maps' },
                        { label: 'Origin Monitoring', to: '/farm-health-scores' },
                        { label: 'Procurement Planning', to: '/supply-risk' },
                        { label: 'EUDR Evidence', to: '/eudr' },
                        { label: 'How It Works', to: '/how-it-works' },
                      ].map(({ label, to }) => (
                        <li key={label} className="col-12"><Link className="fs-7" to={to}>{label}</Link></li>
                      ))}
                    </ul>
                  </div>
                </Col>

                {/* Solutions */}
                <Col sm="6" lg="2" style={{ marginLeft: '-3rem' }}>
                  <div className="nl-footer-info">
                    <h5 className="mb-3 mb-md-4">Solutions</h5>
                    <ul className="row gy-1 gy-sm-3">
                      {[
                        { label: 'Farming', to: '/coop-training' },
                        { label: 'Washing Stations', to: '/purchasing-cherry' },
                        { label: 'Buyers', to: '/farm-health-scores' },
                        { label: 'Traceability', to: '/traceability' },
                      ].map(({ label, to }) => (
                        <li key={label} className="col-12"><Link className="fs-7" to={to}>{label}</Link></li>
                      ))}
                    </ul>
                  </div>
                </Col>

                {/* Resources */}
                <Col sm="6" lg="3">
                  <div className="nl-footer-info">
                    <h5 className="mb-3 mb-md-4">Resources</h5>
                    <ul className="row gy-1 gy-sm-3">
                      {[
                        { label: 'Methodology', to: '/methodology' },
                        { label: 'Blog', to: '/blog' },
                        { label: 'FAQ', to: '/faq' },
                        { label: 'About GAP77', to: '/about-gap-77' },
                      ].map(({ label, to }) => (
                        <li key={label} className="col-12"><Link className="fs-7" to={to}>{label}</Link></li>
                      ))}
                    </ul>
                  </div>
                </Col>

                {/* Company */}
                <Col sm="6" lg="2">
                  <div className="nl-footer-info">
                    <h5 className="mb-3 mb-md-4">Company</h5>
                    <ul className="row gy-1 gy-sm-3">
                      {[
                        { label: 'Contact Sales', to: '/contact-us-solution' },
                        { label: 'All Rights', to: '/all-rights' },
                        { label: 'Terms & Conditions', to: '/terms-and-conditions' },
                        { label: 'Privacy Policy', to: '/privacy-policy' },
                      ].map(({ label, to }) => (
                        <li key={label} className="col-12"><Link className="fs-7" to={to}>{label}</Link></li>
                      ))}
                    </ul>
                    <div style={{ width: '600px', height: '420px', overflow: 'hidden', marginTop: '4rem', marginLeft: '-28rem', opacity: 0.85 }}>
                      <img src="images/ws-icon-green.webp" alt="Weathersafe" style={{ width: '600px', height: 'auto', display: 'block', opacity: 0.15 }} loading="lazy" />
                    </div>
                  </div>
                </Col>

              </Row>
            </Container>
          </div>
          <div className="nl-footer-bottom pt-2 pb-0" style={{ marginTop: '-11rem' }}>
            <Container>
              <Row className="nl-footer-content gx-0 align-items-center justify-content-between">
                <Col lg="6" className="px-0">
                  <p className="fs-7 text-center text-lg-start">&copy; 2013 - <span id="currentYear"> {new Date().getFullYear()} </span>
                    <Link className="fw-bold" style={{ color: '#28a745' }} to="https://www.weathersafe.co.uk/" target="_blank">Weathersafe</Link>. All Rights Reserved.
                  </p>
                  <ul className="nl-footer-social" style={{ gap: '0.25rem', marginTop: '-1rem' }}>
                    <li data-tooltip="Facebook"><NioMedia href="#" size="lg" icon="facebook-f" aria-label="Weathersafe on Facebook" style={{ color: '#6c757d', background: 'none', boxShadow: 'none' }} /></li>
                    <li data-tooltip="LinkedIn"><NioMedia href="#" size="lg" icon="linkedin" aria-label="Weathersafe on LinkedIn" style={{ color: '#6c757d', background: 'none', boxShadow: 'none' }} /></li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </footer>
  );
}
